/**
 * Format the size of a file
 * @param bytes Size file
 */

export function formatSizeUnits(bytes: number) {
  let stringBytes = '';
  if (bytes >= 1073741824) {
    stringBytes = (bytes / 1073741824).toFixed(2) + ' GB';
  } else if (bytes >= 1048576) {
    stringBytes = (bytes / 1048576).toFixed(2) + ' MB';
  } else if (bytes >= 1024) {
    stringBytes = (bytes / 1024).toFixed(2) + ' KB';
  } else if (bytes > 1) {
    stringBytes = bytes + ' bytes';
  } else if (bytes === 1) {
    stringBytes = bytes + ' byte';
  } else {
    stringBytes = '0 bytes';
  }
  return stringBytes;
}
